/* tslint:disable:no-shadowed-variable prefer-const */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class FSAppsService {
  private endpoint = environment.apiUrl + 'auth/';

  constructor(private http: HttpClient) {}

  /**
   * @returns redirects to fsapps login
   */
  login() {
    return this.http.get(this.endpoint + `login-url`);
  }

  /**
   * @returns gets token from fsapps
   */
  getToken(code: string) {
    return this.http.get(this.endpoint + `token/${code}`);
  }
}
